<template>
  <v-container text-xs-center>
    <div class="elevation-5">
      <!-- Container for tabs and buttons -->
      <div class="tabs-container">
        <!-- Centered Tabs -->
        <v-tabs v-model="mainTab" dark background-color="light-blue darken-4" show-arrows fixed-tabs
          @change="updateRouter" class="centered-tabs">
          <v-tab key="dataTable">Athlete's Tab</v-tab>
          <v-divider vertical style="margin: 0 8px"></v-divider>
          <v-tab key="pivotTable">Athlete's Pivot Table</v-tab>
        </v-tabs>

        <!-- Right-aligned buttons (only for admin) -->
        <div class="admin-buttons" v-if="isAdmin()">
          <!-- Search Input -->
          <v-text-field v-if="searchVisible" v-model="search" label="Search Athlete" single-line hide-details filled
            rounded dense style="max-width: 130px" class="white-search">
          </v-text-field>
          <!-- Expandable Search Icon -->
          <v-icon color="primary" @click="searchVisible = !searchVisible; search = '';" style="cursor: pointer">
            search
          </v-icon>

          <v-divider vertical style="margin: 0 8px"></v-divider>

          <v-dialog v-model="dialogFilter" :retain-focus="false" max-width="700px" persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" dark v-on="on" v-bind="attrs">
                tune
              </v-icon>
            </template>

            <v-card>
              <v-card-text>
                <span class="headline">Athlete's Settings</span>
                <v-divider style="margin: 8px"></v-divider>
                <v-flex xs12>
                  <v-select v-model="status_selected" :items="statusOptions" v-if="isAdmin()" @change="handleSelection"
                    :menu-props="{ maxHeight: '400' }" label="Status" multiple dark outlined dense hide-details
                    clearable class="light-blue darken-4 select_tab_bar">
                    >
                    <template v-slot:prepend-item>
                      <v-list-item-group>
                        <v-list-item @click="selectAll">
                          <v-list-item-content>
                            <v-list-item-title>Select All</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="selectNone">
                          <v-list-item-content>
                            <v-list-item-title>Select None</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                      <v-divider></v-divider>
                    </template>
                  </v-select>
                </v-flex>
                <v-divider style="margin: 8px"></v-divider>
                <v-flex xs12>
                  <catValueDropDown :outlined="true" v-model="participationDaysFilter" label="Participation Days"
                    catName="WEEKDAYS" :multiList="true" />
                </v-flex>
                <v-divider style="margin: 12px"></v-divider>
                <span class="headline">System Settings</span>
                <v-divider style="margin: 8px"></v-divider>
                <v-icon :color="tableMobile == 0 ? 'grey' : 'primary'" small class="mr-2"
                  @click="tableMobile = tableMobile == 0 ? 600 : 0">
                  display_settings
                </v-icon>
                <span>{{ "Mobile Display" }} </span>
                <v-divider style="margin: 12px"></v-divider>
              </v-card-text>

              <v-card-actions>
                <v-btn color="primary" @click="dialogFilter = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-divider vertical style="margin: 0 8px"></v-divider>

          <v-dialog v-model="dialog" :retain-focus="false" max-width="700px" persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" dark v-on="on" v-bind="attrs">
                person_add_alt_1
              </v-icon>
            </template>
          </v-dialog>
        </div>
      </div>
      <!-- Tab Content -->
      <v-tabs-items v-model="mainTab">
        <!-- Athlete's Tab -->
        <v-tab-item key="dataTable">
          <!-- Athlete's Tab Content -->
          <v-tabs v-model="tab" color="white" dark background-color="light-blue darken-4" show-arrows fixed-tabs>
            <v-tabs-slider color="white"></v-tabs-slider>
            <v-tab v-for="item in groupListFiltered" :key="item.node.teamId" :href="'#' + `${item.node.teamName}`"
              @click="updateRouter()">
              {{ getTabName(item) }}
            </v-tab>
            <v-tabs-items v-if="mainTab === 0" v-model="tab">
              <v-tab-item v-for="subitem in groupListFiltered" :key="subitem.node.teamId"
                :value="subitem.node.teamName">
                <v-data-table
                      :mobile-breakpoint="tableMobile"
                      :headers="headers"
                      :items="getCurrentAthletes(subitem)"
                      :search="search"
                      :custom-filter="customFilter"
                      :page.sync="page"
                      :items-per-page="itemsPerPage"
                      hide-default-footer
                      @page-count="pageCount = $event"
                      show-group-by
                      :loading="loadingTable"
                      loading-text="Loading, please wait..."
                      background-color="primary"
                      :sort-by="'node.status'"
                      :sort-desc="false"
                      :item-class="getItemClass"
                    >
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on">New Item</v-btn>
                    </template>
                  <template #footer>
                    <v-btn color="primary" v-if="isAdmin()" @click="sendEmail(getCurrentAthletes(subitem))">
                      Send Group Email
                    </v-btn>
                    <v-btn color="primary" v-if="isAdmin()" @click="copyToClipboard(getCurrentAthletes(subitem))">
                      Emails to ClipBoard
                    </v-btn>
                    <v-btn color="primary" v-if="isAdmin()" class="no-print" @click="printPage">Print Table</v-btn>
                  </template>
                  <template v-slot:[`item.node.email`]="{ item }">
                    <div class="truncate-for-print">
                      {{ item.node.email + " | " + item.node.phone }}
                    </div>
                  </template>
                  <template v-slot:[`item.node.firstName`]="{ item }">
                    <div>
                      {{ item.node.firstName + " " + item.node.lastName }}
                    </div>
                  </template>

                  <template v-slot:[`item.node.additionalInfo`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="text-truncate">
                          {{ truncateText(item.node.additionalInfo, 30) }}
                        </div>
                      </template>
                      <span>{{ item.node.additionalInfo }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.node.tryoutDatetime`]="{ item }">
                    <div>
                      <td class="truncate-for-print">
                        {{ formatDatetime(item.node.tryoutDatetime) }}
                      </td>
                    </div>
                  </template>
                  <template v-slot:[`item.node.updateDate`]="{ item }">
                    <div>
                      <td class="truncate-for-print">
                        {{
                          item.node.updateDate
                            ? item.node.updateDate.slice(0, 10)
                            : null
                        }}
                      </td>
                    </div>
                  </template>
                  <template v-slot:[`item.node.participationDays`]="{ item }">
                    <div>
                      <template v-if="isValidJSON(item.node.participationDays)">
                        <div style="display: flex; flex-wrap: wrap; align-items: center">
                          <v-chip>
                            {{
                              JSON.parse(item.node.participationDays).join(", ")
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </div>
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                    <!-- v-menu that is triggered by the three dots button -->
                    <v-menu offset-y open-on-hover>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn x-small color="primary" dark v-bind="attrs" v-on="on">
                          <v-icon small>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <!-- Menu content (will only be visible when the menu is active) -->
                      <v-list>
                        <!-- Edit Action -->
                        <v-list-item @click="edit(item.node)">
                          <v-list-item-icon>
                            <v-icon>edit</v-icon>
                            <!-- Edit icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="sendEmail(item.node)">
                          <v-list-item-icon>
                            <v-icon>email</v-icon>
                            <!-- Edit icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Email: {{ item.node.email }} </v-list-item-title>
                        </v-list-item>
                        <v-list-item :href="'tel:' + item.node.phone">
                          <v-list-item-icon>
                            <v-icon>phone</v-icon>
                            <!-- Edit icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Call: {{ item.node.phone }} </v-list-item-title>
                        </v-list-item>

                        <!-- <v-btn x-small @click="sendEmail(item.node)">
                    {{ item.node.email }}
                  </v-btn> -->

                        <!-- Delete Action -->
                        <v-list-item @click="athleteDelete(item.node)">
                          <v-list-item-icon>
                            <v-icon>delete</v-icon>
                            <!-- Delete icon -->
                          </v-list-item-icon>
                          <v-list-item-title>Delete</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>

                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                  </v-alert>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-tab-item>
        <v-tab-item key="pivotTable">
          <v-container>
            <PivotTable v-if="mainTab === 1" v-show="formattedPivotData.length !== 0" :data="formattedPivotData"
              :inProfileName="profileName" @profile-selected="handleProfileChange" />
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <v-alert dense type="info" outlined>
      <v-chip class="row-declined">Declined</v-chip> - Athlete declined
      participation

      <v-chip class="row-old">Old</v-chip> - No update 5+ days for
      qualified/tryout, 10+ for confirmed, 31+ for waitlist

      <v-chip class="row-dead">Dead</v-chip> - No response after follow-ups for
      90days+ from create
      <v-chip class="row-active">Active</v-chip>
      - Active Athletes.
    </v-alert>

    <!-- Add athlete dialog -->
    <v-dialog v-model="dialog" :retain-focus="false" max-width="900px" persistent>
  <v-card>
    <v-card-title>
      <span class="headline">{{ formTitle }}</span>
    </v-card-title>

    <v-card-text>
      <v-tabs v-model="activeTab" background-color="primary" dark>
        <v-tab>Info</v-tab>
        <v-tab>Communications</v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <!-- Info Tab -->
        <v-tab-item>
          <v-container grid-list-md>
            <v-form v-model="isFormValid" lazy-validation ref="form" @submit.prevent="handleAddAthlete">
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field v-model="editedItem.firstName" label="Athlete Name" :rules="nameRules" :counter="50"
                    required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="editedItem.lastName" label="Athlete Last Name" :rules="nameRules" :counter="50"
                    required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="editedItem.email" label="E-Mail" :rules="emailRules" required
                    hint="Use (;) semicolon separator for multiple emails"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="editedItem.phone" label="Phone" :rules="phoneRules" required
                    hint="Use (;) semicolon separator for multiple phones"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-autocomplete v-model="editedItem.teamId" :rules="requiredRule" required
                    :hint="`${editedItem.teamId}`" label="Select Team Name" :items="groupList" item-value="node.teamId"
                    item-text="node.teamName" chips>
                  </v-autocomplete>
                </v-flex>
                <!-- <v-flex xs12 sm6>
                  <v-text-field
                    v-model="editedItem.language"
                    label="Language"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="editedItem.country"
                    label="Country"
                  ></v-text-field>
                </v-flex> -->
                <v-flex xs12 sm6>
                  <v-select v-model="editedItem.status" :items="catValueListArray('athlete_status')" label="Status"
                    :rules="requiredRule" required></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select v-model="editedItem.gender" :items="['male', 'female']" label="Gender"
                    :rules="requiredRule"></v-select>
                </v-flex>
                <!-- <v-flex xs12 sm6>
                  <v-text-field
                    v-model="editedItem.photo"
                    label="Photo"
                  ></v-text-field>
                </v-flex> -->

                <v-flex xs12 sm6>
                  <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                    offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="editedItem.birthDate" label="Birth Date" prepend-inner-icon="event"
                        v-on="on" v-bind="attrs" :rules="requiredRule"></v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.birthDate" @input="menu = false" required></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex>
                  <v-textarea v-model="editedItem.additionalInfo" label="Additional Info" rows="4"
                    auto-grow></v-textarea>
                </v-flex>
                <v-flex>
                  <catValueDropDown :outlined="true" v-model="editedItem.participationDays" label="Participation Days"
                    catName="WEEKDAYS" :multiList="true" />
                </v-flex>
                <v-flex>
                  <v-checkbox v-model="editedItem.registrationState" label="Registration Forms"></v-checkbox>
                </v-flex>
                <v-flex>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y
                        min-width="290px">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-model="editedItem.tryoutDate" label="Tryout Date" readonly
                            prepend-inner-icon="event" v-bind="attrs" v-on="on" clearable
                            clear-icon="close"></v-text-field>
                        </template>
                        <v-date-picker v-model="editedItem.tryoutDate" @input="dateMenu = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-menu v-model="timeMenu" :close-on-content-click="false" transition="scale-transition" offset-y
                        min-width="290px">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-model="editedItem.tryoutTime" label="Tryout Time" readonly v-bind="attrs"
                            v-on="on" prepend-inner-icon="access_time" clearable clear-icon="close"></v-text-field>
                        </template>
                        <v-time-picker v-model="editedItem.tryoutTime" format="24hr"
                          :allowed-times="allowedTimes"></v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-flex>
                <v-flex>
                  <v-text-field type="number" v-model="editedItem.volunteerHours"
                    label="Volunteer Hours"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-tab-item>

        <!-- Communications Tab -->
        <v-tab-item>
          <v-container>
            <Communications :leadId="editedItem.leadId" :phone="editedItem.phone" :email="editedItem.email" />
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="close">Cancel</v-btn>
      <v-btn :disabled="!isFormValid || loading" color="blue darken-1" text @click="editAthlete">Save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-container>
</template>

<script>
/* eslint-disable prettier/prettier */
import { mapGetters, mapActions } from "vuex";
import { randomInteger } from "../../../_helpers/index";
import { nanoid } from "nanoid";
import BaseToolbar from "../../base/BaseToolbar.vue";
import { getCatValues } from "../../../mixins/getCatValues.js";
import catValueDropDown from "../../shared/cat_val_dropdown.vue";
import { hasJsonStructure } from "../../../_helpers/index";
import PivotTable from "../common/Report/PIvotTable.vue";
import Communications from "./PersonCommunications.vue";
import 'vue-pivottable/dist/vue-pivottable.css'
// import { VuePivottableUi } from 'vue-pivottable'
// import PivotTable from 'vue-pivottable';

export default {
  components: { BaseToolbar, catValueDropDown, PivotTable,Communications },
  mixins: [getCatValues],
  data() {
    return {
      props: {
        profileName: {
          type: String,
          default: function () {
            return ''
          }
        }
      },
      loadingPivot: true, // Indicates pivot table is loading data
      pivotProps: {},
      // selectedPivotFields: [],
      // pivotFields: [
      //   { text: 'Athlete Name', value: 'Athlete Name' },
      //   { text: 'Athlete Last Name', value: 'Athlete Last Name' },
      //   { text: 'Group', value: 'Group' },
      //   { text: 'Status', value: 'Status' },
      //   { text: 'tryoutDatetime', value: 'tryoutDatetime' },
      //   { text: 'gender', value: 'gender' },
      //   { text: 'additionalInfo', value: 'additionalInfo' },
      //   { text: 'birthDate', value: 'birthDate' },
      //   { text: 'email', value: 'email' },
      //   { text: 'updateDate', value: 'updateDate' },
      //   { text: 'updateSource', value: 'updateSource' },
      //   { text: 'participationDays', value: 'participationDays' },
      //   { text: 'createDate', value: 'createDate' },
      //   { text: 'sourceOfInformation', value: 'sourceOfInformation' },
      //   { text: 'volunteerHours', value: 'volunteerHours' },
      //   { text: 'registrationState', value: 'registrationState' },
      //   { text: 'ClubName', value: 'clubName' }

      // ],
      mainTab: 0,
      activeTab: 0,
      tableMobile: 0,
      page: 1,
      itemsPerPage: 150,
      pageCount: 0,
      tab: "Elite",
      isFormValid: true,
      searchVisible: false,
      status: "active",
      search: "",
      loadingTable: true,
      dialog: false,
      dialogFilter: false,
      menu: false,
      //TODO Take out this validation rules. We have the same in global const
      name: "Default",
      status_selected: [],
      participationDaysFilter: [],
      dateMenu: false,
      timeMenu: false,
      // status_selected: ['active', 'tryout', 'deposit', 'paid', 'waitlist',''],
      //status_selected: this.catValueListArray('athlete_status').filter(status => status !== "inactive"),
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 50) || "Name must be less than 10 characters",
      ],
      requiredRule: [(v) => !!v || "Value is required"],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+)(\s*;\s*(\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+))*$/.test(
            v
          ) || // eslint-disable-line
          "E-mail must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Phone number is required",
        (v) =>
          /^\+?\d{1,3}[-\s]?\(?\d{3}\)?[-\s]?\d{3}[-\s]?\d{4}(;\s*\+?\d{1,3}[-\s]?\(?\d{3}\)?[-\s]?\d{3}[-\s]?\d{4})*$/.test(
            v
          ) || "Phone number must be valid",
      ],
      editedIndex: -1,
      editedItem: {
        firstName: "",
        lastName: "",
        status: 0,
        birthDate: "",
        photo: "",
        gender: 0,
        email: "",
        // language: "",
        // country: 0,
        additionalInfo: "",
        participationDays: "",
        registrationState: false,
        //tryoutDate: new Date().toISOString().split('T')[0],
        //tryoutTime: "18:00",
        tryoutDate: null,
        tryoutTime: null,
        volunteerHours: 0,
        teamId: 0,
      },
      //TODO Take out this hardcode
      defaultItem: {
        firstName: "",
        lastName: "",
        status: 0,
        birthDate: "",
        photo: "",
        gender: 0,
        email: "",
        // language: "",
        // country: 0,
        additionalInfo: "",
        participationDays: "",
        registrationState: false,
        //tryoutDate: new Date().toISOString().split('T')[0],
        //tryoutTime: "18:00",
        tryoutDate: null,
        tryoutTime: null,
        volunteerHours: 0,
        teamId: 0,
      },
      allowedTimes: ["17:00", "18:00", "19:00"],
    };
  },
  async created() {
    this.setDefaultPivotProps();
    this.editedItem.status = "active";
    await this.allAthlete({ clubId: this.$route.params.club })
      .then(() => (this.loadingTable = false))
      .catch((error) => {
        this.loadingTable = false;
        //console.error(error);
      });
    await this.allClub({ clubId: this.$route.params.club })
      .then(() => (this.loadingTable = false))
      .catch((error) => {
        //console.error(error);
        this.loadingTable = false;
      });

    if (!(Object.entries(this.$route.query).length === 0)) {
      const { tab, subTab, status } = this.$route.query;
      this.mainTab = tab === 'pivotTable' ? 1 : 0;
      if (subTab) {
        this.tab = subTab;
      }
      this.status_selected = status || [];
    }
    if (this.status_selected.length == 0) {
      this.status_selectedOnce();
    }
  },
  computed: {
    ...mapGetters([
      "loading",
      "athleteList",
      "groupList",
      "user",
      "hasUser",
      "clubInfo",
    ]),
    formattedPivotData() {
      if (!this.athleteList || !this.athleteList.edges || !this.athleteList.edges.length) {
        return [];
      }

      return this.athleteList.edges.map((item) => ({
        'Athlete Name': item.node && item.node.firstName + " " + item.node.lastName ? item.node.firstName + " " + item.node.lastName : "N/A",
        // 'Athlete Last Name': item.node && item.node.lastName ? item.node.lastName : "N/A",
        'Group': item.node && item.node.team && item.node.team.teamName ? item.node.team.teamName : "NO_DATA",
        'Status': item.node && item.node.status ? item.node.status : "NO_DATA",
        tryoutDatetime: item.node && item.node.tryoutDatetime ? item.node.tryoutDatetime : "NO_DATA",
        gender: item.node && item.node.gender ? item.node.gender : "NO_DATA/A",
        birthDate: item.node && item.node.birthDate ? item.node.birthDate : "NO_DATA",
        email: item.node && item.node.email ? item.node.email : "NO_DATA",
        additionalInfo: item.node && item.node.additionalInfo ? item.node.additionalInfo : "NO_DATA",
        updateSource: item.node && item.node.updateSource ? item.node.updateSource : "NO_DATA",
        participationDays: item.node && item.node.participationDays ? item.node.participationDays : "NO_DATA",
        createDate: item.node && item.node.createDate ? item.node.createDate : "NO_DATA",
        sourceOfInformation: item.node && item.node.sourceOfInformation ? item.node.sourceOfInformation : "NO_DATA",
        volunteerHours: item.node && item.node.volunteerHours ? item.node.volunteerHours : "NO_DATA",
        registrationState: item.node && item.node.registrationState ? item.node.registrationState : "NO_DATA",
        clubName: (item.node && item.node.club && item.node.club.clubName) ? item.node.club.clubName : "NO_DATA",
        personId: item.node && item.node.athleteId ? item.node.athleteId : "NO_DATA",
        phone: item.node && item.node.phone ? item.node.phone : "NO_DATA",
        homeaddress: item.node && item.node.homeaddress ? item.node.homeaddress : "NO_DATA",
        postalcode: item.node && item.node.postalcode ? item.node.postalcode : "NO_DATA",
        occupation: item.node && item.node.occupation ? item.node.occupation : "NO_DATA",
        formsSigned: item.node && item.node.formsSigned ? item.node.formsSigned : "NO_DATA"
      }));
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Athlete" : "Edit Athlete " + this.editedItem.firstName + " " + this.editedItem.lastName;
    },
    clubInfoNew() {
      return this.clubInfo.edges.filter(
        (item) => item.node.clubId == this.$route.params.club
      );
    },
    funcName() {
      return this.editedIndex === -1 ? this.addNewAthlete : this.editAthlete;
    },
    statusOptions() {
      return [...this.catValueListArray("athlete_status")];
    },
    groupListFiltered() {
      //console.log(this.groupList);
      if (this.groupList) {
        return this.groupList
          .filter(
            (item) =>
              item &&
              (this.isAdmin() ||
                (item.node.teamName.toLowerCase() != "inactive" &&
                  //( item.node.teamName.toLowerCase() != "all" || ( this.status_selected == "qualified" && item.node.teamName.toLowerCase() === "all")) &&
                  ((item.node.teamName.toLowerCase() === "all" &&
                    (this.status_selected == "tryout" ||
                      this.status_selected == "qualified")) ||
                    (item.node.teamName.toLowerCase() != "all" &&
                      !(
                        this.status_selected == "tryout" ||
                        this.status_selected == "qualified"
                      )))))
            // &&  item.node.teamName.toLowerCase() != "tryout"
          )
          .sort((a, b) => a.node.orderOnUi - b.node.orderOnUi);
      } else {
        return [];
      }
    }, // contains only Alex and James
    // Dynamic header to hide sensetive fields:
    headers() {
      let headers = [
        {
          text: "Athlete Name",
          align: "left",
          sortable: true,
          value: "node.firstName",
        },
        // { text: "Athlete Last Name", value: "node.lastName" },
        { text: "Group", value: "node.team.teamName" },
        { text: "Status", value: "node.status" },
      ];

      if (this.isAdmin()) {
        headers.unshift({ text: "Actions", value: "action", sortable: false });

        //        headers.push({ text: "Team", value: "node.team.teamName" });
        //        headers.push({ text: "Status", value: "node.status" });
        headers.push({ text: "Gender", value: "node.gender" });
        headers.push({ text: "Birth Date", value: "node.birthDate" });
        headers.push({ text: "ContactInfo", value: "node.email" });
        //        headers.push({ text: "Phone", value: "node.phone" });
        headers.push({ text: "Tryout DateTime", value: "node.tryoutDatetime" });
        headers.push({ text: "Create Date", value: "node.createDate" });
        headers.push({ text: "Update Date", value: "node.updateDate" });
        headers.push({ text: "Additional Info", value: "node.additionalInfo" });
        headers.push({ text: "Update Source", value: "node.updateSource" });
        headers.push({
          text: "Participation Days",
          value: "node.participationDays",
        });
        headers.push({ text: "Create Date", value: "node.createDate" });
        headers.push({ text: "Lead From", value: "node.sourceOfInformation" });
        //  headers.push({ text: "Status", value: "node.status" });
        headers.push({ text: "Volunteer Hours", value: "node.volunteerHours" });
        headers.push({
          text: "Registration State",
          value: "node.registrationState",
        });
      }

      return headers;
    },
  },

  watch: {
    dialog(val) {
      //console.log(this.groupList);
      if (this.editedIndex === -1) {
        this.editedItem.teamId = this.tab
          ? this.groupList.filter((item) => item.node.teamName == this.tab)[0]
            .node.teamId
          : "";
      }
      val || this.close();
    },
    // selectedPivotFields(newVal) {
    //   console.log('Selected Pivot Fields:', newVal);
    // },
    tab(newVal) {
      if (this.mainTab === 0) { // Only update for dataTable tab
        this.updateRouter();
      }
    },
    athleteList: {
      handler(newVal) {
        this.loadingPivot = !(newVal && newVal.edges && newVal.edges.length > 0);
      },
      immediate: true, // Run this when the component loads
      deep: true, // Ensure it watches deeply for changes
    },
  },

  methods: {
    ...mapActions([
      "addUpdateAthlete",
      "DeleteAthlete",
      //"updateAthlete",
      "allAthlete", 
      "allClub",
    ]),
    // applySelectedFields() {
    //   console.log('Selected Pivot Fields:', this.selectedPivotFields)
    //   this.dialog = false // Close the dialog
    // },
    customFilter(value, search, item) {
    // Search across both firstName and lastName
    const fullName = (item.node.firstName + ' ' + item.node.lastName).toLowerCase();
    const email = (item.node.email || '').toLowerCase();
    const phone = (item.node.phone || '').toLowerCase();
    const additionalInfo = (item.node.additionalInfo || '').toLowerCase();
    
    search = search.toLowerCase();

    return (
      fullName.includes(search) ||
      email.includes(search) ||
      phone.includes(search) ||
      additionalInfo.includes(search)
    );
  },      
    handleProfileChange(profile) {
      this.profileName = profile;
      this.mainTab = 1; // Ensure we're in pivotTable view
      this.$nextTick(() => {
        this.updateRouter();
      });
    },
    truncateText(text, length) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    updateRouter() {
      setTimeout(() => {
        const query = {
          tab: this.mainTab === 0 ? 'dataTable' : 'pivotTable',
        };

        if (this.mainTab === 0) {
          // For dataTable (mainTab=0)
          query.subTab = this.tab;
          query.status = this.status_selected;
        } else {
          // For pivotTable (mainTab=1)
          if (this.profileName) {
            query.profileName = this.profileName;
          }
        }

        this.$router.replace({ query });
      }, 300);
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.tableMobile = 600;
        return true;
      } else {
        return false;
      }
    },
    selectAll() {
      this.status_selected = this.catValueListArray("athlete_status");
      this.updateRouter();
    },
    selectNone() {
      this.status_selected = [];
      this.updateRouter();
    },
    handleSelection() {
      // Remove "Select All" or "Select None" from selection if manually adjusted
      this.status_selected = this.status_selected.filter(
        (item) => !["Select All", "Select None"].includes(item)
      );
      this.updateRouter();
    },
    isValidJSON(value) {
      // Check if value is not null or undefined
      if (value === null || value === undefined) {
        return false;
      }
      try {
        JSON.parse(value);
        return true;
      } catch (e) {
        return false;
      }
    },
    printPage() {
      // Accessing the window object directly
      window.print(); // This triggers the print dialog
    },
    isAdmin() {
      return this.user && this.user.role == "Administrator";
    },
    status_selectedOnce() {
      this.status_selected = this.catValueListArray("athlete_status").filter(
        (status) => status !== "inactive"
      );
    },

    getCurrentAthletes(subItem) {
      //console.log(this.athleteList.edges);
      //console.log(subItem);
      //console.log(JSON.stringify(this.statuslist).includes(item.node.status));

      if (this.athleteList.edges) {
        return this.athleteList.edges.filter(
          (item) =>
            ((item.node.teamId == subItem.node.teamId ||
              subItem.node.teamName == "ALL") &&
              JSON.stringify(this.status_selected).includes(item.node.status) &&
              (this.participationDaysFilter < 1 ||
                !item.node.participationDays ||
                this.participationDaysFilter.some((value) =>
                  item.node.participationDays.includes(value)
                ))) ||
            (item.node.status === "inactive" &&
              item.node.status === subItem.node.teamName.toLowerCase())
        );
      } else {
        return [];
      }
    },
    copyToClipboard(item) {
      // Use the Clipboard API to copy text
      navigator.clipboard
        .writeText(
          item.email != null || item.email != undefined
            ? item.email
            : [...new Set(item.map((user) => user.node.email))]
              .join(",")
              .replace(/,/g, ";")
        )
        .then(() => {
          this.copied = true; // Show success message
          setTimeout(() => (this.copied = false), 2000); // Hide message after 2 seconds
        })
        .catch((err) => {
          //console.error("Failed to copy text: ", err);
        });
    },

    sendEmail(item) {
      // console.log(item);
      // console.log(this.clubInfoNew);
      // console.log(this.groupList);
      // console.log(this.tab);
      var emailBCC =
        item.email != null || item.email != undefined
          ? item.email
          : [...new Set(item.map((user) => user.node.email))]
            .join(",")
            .replace(/,/g, ";");
      var emailSub =
        this.clubInfoNew[0].node.clubName +
        " Club Announcement for group " +
        this.tab;
      var emailBodyUrl =
        "https://portal.sportecos.com/" +
        this.$route.params.club +
        "/club/athlete_list?tab=" +
        this.tab;
      var emailBody =
        " If you got this email, you are part of " +
        this.clubInfoNew[0].node.clubName +
        " Club group " +
        this.tab +
        "\n" +
        "Refer membership under this link " +
        emailBodyUrl;
      var emailTo = "";
      var emailBody = encodeURIComponent(emailBody);
      //window.open(mail + emails);
      location.href =
        "mailto:" +
        emailTo +
        "?bcc=" +
        emailBCC +
        "&subject=" +
        emailSub +
        "&body=" +
        emailBody;
    },
    handleGetClubList() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allClubs", {
        clubId: this.$route.params.club,
      });
    },

    getTeamName: function (item) {
      return this.groupList.find((x) => x.node.teamId == item).node.teamName;
    },

    getTabName(el) {
      if (this.athleteList.edges) {
        const athleteQuantity = this.athleteList.edges.filter(
          (item) =>
            ((item.node.teamId == el.node.teamId ||
              el.node.teamName == "ALL") &&
              JSON.stringify(this.status_selected).includes(item.node.status) &&
              (this.participationDaysFilter < 1 ||
                !item.node.participationDays ||
                this.participationDaysFilter.some((value) =>
                  item.node.participationDays.includes(value)
                ))) ||
            (item.node.status === "inactive" &&
              item.node.status === el.node.teamName.toLowerCase())
        ).length;
        return `${el.node.teamName}(${athleteQuantity})`;
      } else {
        return "";
      }
    },
    addNewAthlete() {
      this.loadingTable = true;
      this.addUpdateAthlete({
        athleteData: {
          //TODO Set first arg from last athlete id
          //athleteId: Number(randomInteger(1, 1321)),
          firstName: String(this.editedItem.firstName),
          lastName: String(this.editedItem.lastName),
          email: String(this.editedItem.email),
          birthDate: this.editedItem.birthDate,
          photo: String(this.editedItem.photo),
          gender: String(this.editedItem.gender),
          // language: String(this.editedItem.language),
          // country: String(this.editedItem.country),
          additionalInfo: String(this.editedItem.additionalInfo),
          participationDays:
            this.editedItem.participationDays &&
              this.editedItem.participationDays.length > 0
              ? JSON.stringify(this.editedItem.participationDays)
              : null,
          createDate: this.moment.format("YYYY-MM-DD"),
          updateSource: "OG App",
          //        phone: $phone
          //        sourceOfInformation: $sourceOfInformation
          //        homeAddress: $homeAddress
          //        postalCode: $postalCode
          //        occupation: $occupation
          status: String(this.editedItem.status),
          //        additionalInfo: $additionalInfo
          clubId: this.$route.params.club,
          teamId: Number(this.editedItem.teamId),
          startMembership: this.moment.format("YYYY-MM-DD"),
          endMembership: null,
          formsSigned: "",
          //participationDays: String(this.editedItem.participationDays),
          registrationState: this.editedItem.registrationState,
          tryoutDatetime:
            this.editedItem.tryoutDate && this.editedItem.tryoutTime
              ? `${this.editedItem.tryoutDate} ${this.editedItem.tryoutTime}`
              : null,
          volunteerHours: this.editedItem.volunteerHours,
          //        athleteCode: String(nanoid()),
          //        athleteCodeType: "nanoid",
        },
      })
        .then(() => {
          this.loadingTable = false;
          this.$toast.success(
            `Athlete ${this.editedItem.firstName} has been added`
          );
          this.close();
        })
        .catch((error) => {
          this.loadingTable = false;
          //console.error(error);
          this.close();
        });
    },
    athleteDelete(athlete) {
      this.loadingTable = true;
      confirm("Are you sure you want to delete this item?") &&
        this.DeleteAthlete({ personId: athlete.athleteId })
          .then(() => {
            this.loadingTable = false;
            this.$toast.error("Athlete has been deleted");
            this.close();
          })
          .catch((error) => {
            //console.error(error);
            this.loadingTable = false;
            this.close();
          });
    },
    dateWithoutTimezone(date) {
      // Get the timezone offset in milliseconds
      //console.log(date);
      //console.log(Object.prototype.toString.call(date));
      const tzoffset = date.getTimezoneOffset() * 60000; // offset in milliseconds

      // Subtract the timezone offset to get the UTC equivalent of the date
      const withoutTimezone = new Date(date.valueOf() - tzoffset)
        .toISOString() // Convert to ISO string (which is in UTC)
        .slice(0, -1); // Remove the 'Z' (since you don't want the 'Z' for UTC)
      //console.log(withoutTimezone);
      return withoutTimezone; // This will be the date without timezone applied
    },
    edit(item) {
      //console.log(item);
      const editedObject = JSON.parse(JSON.stringify(item));

      if (hasJsonStructure(editedObject.participationDays)) {
        editedObject.participationDays = JSON.parse(
          editedObject.participationDays
        );
      }
      //    //console.log(this.groupList);
      this.editedIndex = 1;
      this.editedItem = editedObject;
      this.editedItem.teamId = String(this.editedItem.teamId);
      if (item.tryoutDatetime) {
        const [date, time] = item.tryoutDatetime.split("T");
        //console.log(date);
        //console.log(time);
        if (date) {
          this.editedItem.tryoutDate = date;
        }
        if (time) {
          this.editedItem.tryoutTime = time.substring(0, 5);
        }
      }
      this.editedItem.teamId = String(this.editedItem.teamId);
      this.dialog = true;
    },

    editAthlete() {
      //console.log(this.editedItem);
      //console.log(this.editedItem.tryoutTime);
      this.loadingTable = true;

      const time =
        typeof this.editedItem.tryoutTime !== "undefined" &&
          this.editedItem.tryoutTime !== null &&
          this.editedItem.tryoutTime !== ""
          ? this.editedItem.tryoutTime
          : "00:00";

      //console.log(time);

      if (this.editedItem.tryoutDate && time) {
        const datetime = new Date(`${this.editedItem.tryoutDate} ${time}`);
        //console.log(datetime);
        this.editedItem.tryoutDatetime = this.dateWithoutTimezone(datetime);
      } else {
        this.editedItem.tryoutDatetime = null;
      }

      //console.log(this.editedItem.tryoutDatetime);

      // Clone editedItem to avoid mutating the original object
      const sanitizedItem = { ...this.editedItem };

      // List of fields to exclude
      const fieldsToExclude = [
        "__typename",
        "email",
        "athleteId",
        "lastName",
        "firstName",
        "club",
        "team",
        "updateDate",
        "tryoutDate",
        "tryoutTime",
        "leadId"
      ];

      // Remove unnecessary fields
      fieldsToExclude.forEach((field) => delete sanitizedItem[field]);

      //console.log("Sanitized Data:", sanitizedItem);

      this.addUpdateAthlete({
        athleteData: {
          ...sanitizedItem,
          firstName: String(this.editedItem.firstName),
          lastName: String(this.editedItem.lastName),
          email: String(this.editedItem.email),
          clubId: this.$route.params.club,
          participationDays:
            this.editedItem.participationDays &&
              this.editedItem.participationDays.length > 0
              ? JSON.stringify(this.editedItem.participationDays)
              : null,
          startMembership:
            this.editedIndex === -1
              ? this.moment.format("YYYY-MM-DD")
              : this.editedItem.startMembership,
          endMembership: null,
          formsSigned: "",
          personId: this.editedItem.athleteId,
          updateSource: this.user.userName,
          tryoutDatetime: this.editedItem.tryoutDatetime,
        },
      })
        .then(() => {
          this.loadingTable = false;
          this.$toast.success(
            `Athlete ${this.editedItem.firstName} has been updated`
          );
          // this.close();
        })
        .catch((error) => {
          this.loadingTable = false;
          //console.error(error);
          //this.close();
        });
    },

    getItemClass(item) {
      //console.log(item);
      const now = new Date();
      const updateDate = new Date(item.node.updateDate);
      const createDate = new Date(item.node.createDate);
      const differenceInDays = (now - updateDate) / (1000 * 60 * 60 * 24);
      const differenceInDaysfromCreate =
        (now - createDate) / (1000 * 60 * 60 * 24);
      if (item.node.status === "active") {
        return "row-active";
      } else if (item.node.status === "declined") {
        return "row-declined";
      } else if (
        (item.node.status === "tryout" || item.node.status === "qualified") &&
        differenceInDaysfromCreate > 90
      ) {
        return "row-dead";
      } else if (
        (differenceInDays > 5 &&
          (item.node.status === "qualified" ||
            item.node.status === "tryout")) ||
        (item.node.status === "confirmed" && differenceInDays > 10) ||
        (item.node.status === "waitlist" && differenceInDays > 31)
      ) {
        return "row-old";
      } else if (differenceInDays > 40) {
        return "row-old";
      } else {
        return "";
      }
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    formatDatetime(datetime) {
      // Option 1: JavaScript Date object
      if (datetime) {
        const dateObj = new Date(datetime);
        const formattedDate = dateObj.toISOString().split("T")[0];
        const formattedTime = datetime.split("T")[1].slice(0, 5);
        return `${formattedDate} / ${formattedTime}`;
      }
    },
    setDefaultPivotProps() {
      this.pivotProps.aggregatorName = "List Unique Values";
      this.pivotProps.rendererName = "Table";
      this.pivotProps.rowOrder = "key_a_to_z";
      this.pivotProps.colOrder = "key_a_to_z";
      this.pivotProps.vals = [];
      this.pivotProps.cols = [];
      this.pivotProps.rows = [];
    },
  },
  mounted() {
    this.isMobile();
    this.status_selectedOnce();
    // console.log('Headers Data:', this.headers);
    // console.log('Selected Pivot Fields:', this.selectedPivotFields);
    // console.log('Pivot Props:', this.pivotProps);
    // console.log("this.user");
    // console.log(this.user);
    //        this.status_selected = catValueListArray('athlete_status');
  },
};
</script>

<style>
@media print {

  /* More aggressive page margins */
  @page {
    size: auto;
    margin: 5mm 3mm;
    /* Reduced margins (top/bottom 5mm, left/right 3mm) */
  }

  /* Compact body styling */
  body {
    background: white !important;
    color: black !important;
    font-size: 9pt !important;
    /* Slightly smaller font */
    line-height: 1.2 !important;
    /* Tighter line spacing */
    margin: 0 !important;
    padding: 2mm !important;
    /* Minimal padding */
    width: 100% !important;
  }

  /* Table optimization */
  .v-data-table {
    width: 100% !important;
    max-width: 100% !important;
    border-collapse: collapse !important;
    page-break-inside: auto !important;
    table-layout: fixed !important;
    /* Ensures consistent column widths */
  }

  /* Compact cell styling */
  .v-data-table th,
  .v-data-table td {
    border: 1px solid #ddd !important;
    padding: 2px 3px !important;
    /* Minimal padding */
    text-align: left !important;
    font-size: 8.5pt !important;
    /* Smaller font in cells */
    line-height: 1.1 !important;
    word-break: break-word !important;
    /* Prevent text overflow */
  }

  /* Header styling */
  .v-data-table thead th {
    background-color: #f5f5f5 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    font-weight: bold !important;
    font-size: 9pt !important;
  }

  /* Hide everything non-essential */
  .no-print,
  .v-data-footer,
  .v-data-table__progress,
  .v-btn,
  .v-toolbar,
  .v-pagination {
    display: none !important;
  }

  /* Page break control */
  tr {
    page-break-inside: avoid !important;
    page-break-after: auto !important;
  }

  /* Optional: alternate row colors */
  .v-data-table tbody tr:nth-child(odd) td {
    background-color: #f9f9f9 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* Force landscape orientation for wide tables */
  @page {
    size: landscape;
  }

  /* Column width optimization */
  .v-data-table {
    transform: scale(0.95) !important;
    transform-origin: 0 0 !important;
  }
}

.row-active {
  background-color: #e8f5e9;
  /* Light green background */
  color: #388e3c;
  /* Dark green text */
}

.row-old {
  background-color: #ffebee;
  /* Light red background */
  color: #b71c1c;
  /* Dark red text */
}

.row-dead {
  background-color: #e0e0e0;
  /* Light gray background */
  color: #757575;
  /* Dark gray text */
}

.row-declined {
  background-color: #fff3e0;
  /* Light amber background */
  color: #ff9800;
  /* Amber text */
}

.hide-title {
  display: none;
}
</style>

<style scoped>
.white-search {
  background-color: white !important;
}

.white-search .v-input__control {
  background-color: white !important;
}

.white-search .v-input__slot {
  background-color: white !important;
}

.white-search input {
  color: black !important;
}

.white-search label {
  color: rgba(0, 0, 0, 0.6) !important;
}

.tabs-container {
  position: relative;
  display: flex;
  justify-content: center;
  background-color: light-blue darken-4;
}

.centered-tabs {
  margin: 0 auto;
}

.admin-buttons {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  padding-right: 16px;
  background-color: inherit;
  z-index: 1;
}

/* Ensure the tabs take full width */
.v-tabs {
  width: 100%;
}

/* Adjust the tab slider to account for the buttons */
.v-tabs-slider {
  margin-left: auto;
  margin-right: auto;
}
</style>